// extracted by mini-css-extract-plugin
export var bubble = "_k-0";
export var container = "_k-f";
export var contrastBorder = "_k-g";
export var greyOut = "_k-2";
export var initialsColor0 = "_k-3";
export var initialsColor1 = "_k-4";
export var initialsColor10 = "_k-d";
export var initialsColor11 = "_k-e";
export var initialsColor2 = "_k-5";
export var initialsColor3 = "_k-6";
export var initialsColor4 = "_k-7";
export var initialsColor5 = "_k-8";
export var initialsColor6 = "_k-9";
export var initialsColor7 = "_k-a";
export var initialsColor8 = "_k-b";
export var initialsColor9 = "_k-c";
export var initialsWrapper = "_k-1";
export var large = "_k-l";
export var medium = "_k-k";
export var mediumSmall = "_k-j";
export var mediumSmallMedium = "_k-o";
export var micro = "_k-h";
export var small = "_k-i";
export var tiny = "_k-n";
export var xTiny = "_k-m";